<template lang="pug">
    div.resolve-order
        el-dialog(
            :title="'工单完善'"
            :visible.sync="dialogData.show"
            :close-on-click-modal="false"
            width="865px"
            center
        )
            div.resolve-order-content(v-loading="loading")
                div.base-info
                    div.info-item
                        div.item-label 车牌号：
                        div.item-value {{ detailData.plateNumber | fieldVaild }}
                    div.info-item
                        div.item-label 联系人：
                        div.item-value {{ detailData.contactName | fieldVaild }} {{ detailData.contactPhone }}
                    div.info-item
                        div.item-label 车架号：
                        div.item-value {{ detailData.vin | fieldVaild }}
                    div.info-item
                        div.item-label 车型：
                        div.item-value {{ detailData.vehicleModel | fieldVaild }}
                    div.info-item
                        div.item-label 当前里程数(km)：
                        div.item-value {{ detailData.currentMileage | fieldVaild }}
                    div.info-item
                        div.item-label 工单编号：
                        div.item-value {{ detailData.id | fieldVaild }}
                div(style="flex: 1")
                    div.tab-header
                        div.tab-item.active(
                            v-for="tab in stepTabs"
                            :key="tab.value")
                            svg-icon.icon(icon-class="step-waiting")
                            span {{ tab.name }}
                            div.blue-border
                    pre-check(v-show="currentStep === 'preCheck'" form-type="complete" :loading="loading" :detail-data="detailData" @submit="submitData" @viewImg="viewImg")
                    maintenance-check(v-show="currentStep === 'maintenanceCheck'" form-type="complete" :loading="loading" :detail-data="detailData" @submit="submitData" @viewImg="viewImg")
                    maintenance(v-show="currentStep === 'maintenance'" form-type="complete" :loading="loading" :detail-data="detailData" @submit="submitData" @viewImg="viewImg")
                    component-car(v-show="currentStep === 'component'" form-type="complete" :loading="loading" :detail-data="detailData" @submit="submitData" @viewImg="viewImg")
                    spray-paint(v-show="currentStep === 'sprayPaint'" form-type="complete" :loading="loading" :detail-data="detailData" @submit="submitData" @viewImg="viewImg")
                    vehicle-painting(v-show="currentStep === 'vehiclePainting'" form-type="complete" :loading="loading" :detail-data="detailData" @submit="submitData" @viewImg="viewImg")
        image-viewer(
            v-if="showViewer"
            :showViewer.sync="showViewer"
            :currentUrl="currentUrl"
            :urlList="urlList"
        )
</template>

<script>
import { mapState } from 'vuex';
import { workOrderApis } from '@/api';
import PreCheck from './resolveForm/PreCheck.vue';
import MaintenanceCheck from './resolveForm/MaintenanceCheck.vue';
import SprayPaint from './resolveForm/SprayPaint.vue';
import Maintenance from './resolveForm/Maintenance.vue';
import VehiclePainting from './resolveForm/VehiclePainting.vue';
import ComponentCar from './resolveForm/Component.vue';
import ImageViewer from '@/components/ImageViewer.vue';

export default {
    name: 'ResolveOrderMaintain',
    components: {
        PreCheck,
        MaintenanceCheck,
        Maintenance,
        SprayPaint,
        VehiclePainting,
        ComponentCar,
        ImageViewer,
    },
    props: {
        dialogData: {
            type: Object,
            default() {
                return {
                    show: false,
                    id: '',
                };
            },
        },
    },
    data() {
        return {
            loading: false,
            detailData: {},
            // 车辆监测环节
            allTabs: [
                { name: '车辆预检', value: 'preCheck' },
                { name: '保养检测', value: 'maintenanceCheck' },
                { name: '配件处理', value: 'component' },
                { name: '车辆保养', value: 'maintenance' },
                { name: '钣金施工', value: 'sprayPaint' },
                { name: '车辆喷漆', value: 'vehiclePainting' },
            ],
            currentStep: '', // 当前环节

            showViewer: false,
            urlList: [],
            currentUrl: '',
        };
    },
    computed: {
        ...mapState('user', [
            'userInfo',
        ]),
        stepTabs() {
            return this.allTabs.filter(item => (item.value === this.dialogData.stepName));
        },
    },
    mounted() {
        this.currentStep = this.dialogData.stepName;
        this.getOrderDetail();
    },
    methods: {
        async getOrderDetail() {
            try {
                this.loading = true;
                const { data } = await workOrderApis.getWorkOrderDetail(this.dialogData.id);
                this.detailData = data;
            } catch (error) {
                this.detailData = {};
                throw new Error(error);
            } finally {
                this.loading = false;
            }
        },
        handleCancel() {
            this.dialogData.show = false;
        },
        async submitData($event) {
            if (this.loading === true) return;
            const formData = JSON.parse(JSON.stringify($event.data));
            const itemName = formData.stepName;
            delete formData.stepName;
            try {
                this.loading = true;
                const { code } = await workOrderApis.completeWorkOrder(this.dialogData.id, {
                    content: formData,
                    itemName,
                });
                if (code === 0) {
                    this.$message({
                        message: '提交成功',
                        type: 'success',
                    });
                    this.handleCancel();
                    this.$emit('refresh');
                }
            } catch (error) {
                throw new Error(error);
            } finally {
                this.loading = false;
            }
        },
        viewImg($event) {
            this.currentUrl = $event.url;
            this.urlList = $event.urls;
            this.showViewer = true;
        },
    },
};
</script>
<style lang="scss" scoped>
    .resolve-order {
        &-content {
            display: flex;
            .base-info {
                width: 280px;
                min-height: 350px;
                background: #F9F9F9;
                font-size: 14px;
                font-weight: 400;
                padding: 20px;
                .info-item {
                    display: flex;
                    min-height: 20px;
                    line-height: 20px;
                    margin-bottom: 20px;
                    .item-label {
                        color: #999999;
                        white-space: nowrap;
                    }
                    .item-value {
                        color: #333333;
                    }
                }
            }
            .tab-header {
                width: 100%;
                height: 40px;
                border-bottom: 1px solid rgba(0,0,0,0.06);
                display: flex;
                .tab-item {
                    width: 124px;
                    line-height: 40px;
                    text-align: center;
                    font-size: 14px;
                    color: rgba(0,0,0,0.65);
                    font-weight: 400;
                    cursor: pointer;
                    .icon {
                        margin-right: 5px;
                    }
                    &.active {
                        color: #2970FF;
                        font-weight: bolder;
                        position: relative;
                        .blue-border {
                            width: 76px;
                            height: 4px;
                            background: #2970FF;
                            position: absolute;
                            bottom: 0;
                            left: 24px;
                        }
                    }
                }
            }
        }
    }
</style>
<style lang="scss">
    .resolve-order {
        .dialog-footer {
            display: flex;
            width: 100%;
            justify-content: center;
        }
        .button {
            margin: 0 25px;
            width: 110px;
        }
        .el-dialog__body {
            padding: 0!important;
        }
        .el-dialog__footer {
            padding: 0 0 20px 0!important;
        }
        .el-form-item__label {
            width: 114px;
            padding: 0;
        }
    }
</style>
